'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _constants = require('./constants');
exports.default = function (reducer) {
  return function (state, action) {
    if (action.type === _constants.actionTypes.LOGOUT) {
      state = {
        query: state.query
      };
    }
    return reducer(state, action);
  };
};